import React from 'react';
import {Modal, Row, Col} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import ReceiptTable from "./ReceiptTable";
import logo from "../../../assets/images/bim-logo.png";
import logodark from "../../../assets/images/bim-logo-dark.png";
import ReceiptHeader from "./ReceiptHeader";
import ReceiptSummary from "./ReceiptSummary";
import {useSelector} from "react-redux";
import {LAYOUT_MODE_TYPES} from "../../../Common/constants/layout";


interface ComparisonModalProps {
    show: boolean;
    onClose: () => void;
    receipts: any[];
}

const ComparisonModal: React.FC<ComparisonModalProps> = ({show, onClose, receipts}) => {
    const {t} = useTranslation();
    const layout = useSelector((state: any) => state.Layout);

    return (
        <Modal show={show} onHide={onClose} fullscreen centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="logo logo-dark">
                        {
                            layout.layoutModeType === LAYOUT_MODE_TYPES.LIGHTMODE ?
                                <span className="logo-sm"><img src={logo} alt="" height="22"/></span> :
                                <span className="logo-lg"><img src={logodark} alt="" height="21"/></span>
                        }
                    </div>
                </Modal.Title>
                <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{overflowX: 'auto'}}>
                <Row xs={1} md={receipts.length}>
                    {receipts.map((receipt, idx) => (
                        <Col key={idx}>
                            <div style={{border: '1px solid #ccc', borderRadius: 4, padding: 12, marginBottom: 16}}>
                                <ReceiptHeader receipt={receipt} />
                                <hr/>
                                <h6>{t('Receipt.items')}</h6>
                                <ReceiptTable items={receipt.items} />

                                <hr/>
                                <h6>{t('Receipt.summary')}</h6>
                                <ReceiptSummary receipt={receipt} />
                            </div>
                        </Col>
                    ))}
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default ComparisonModal;
